import { useEffect, useState } from 'react'

/**
 * Returns false during SSR and the first client render, then true after mount.
 *
 * Use this to gate any rendering that depends on browser-only APIs
 * (e.g. `matchMedia` via react-responsive's `useMediaQuery`). Those APIs are
 * unavailable on the server, so the server and the first client render must
 * agree on a single value — otherwise React throws a hydration mismatch.
 * Reading viewport/media state only once `hasMounted` is true keeps the first
 * client paint identical to the server output.
 */
export function useHasMounted() {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  return hasMounted
}
